import { useRouter } from "next/router";
import { IMarketFilters } from "../../../common/commonTypes";
import { getMarketFilterValues } from "../../../helpers/marketHelper";

import { useMarketQuery } from "../../../queries/market.query";
import { getPagesItems } from "../../../helpers/paginationHelper";
import { parseQueryParams } from "../../../helpers/nextHelper";

function useMarket() {
  const router = useRouter();
  const { query } = router;

  const filterValues = getMarketFilterValues(query);

  const { data, fetchNextPage, isLoading, error, hasNextPage } =
    useMarketQuery(filterValues);

  const setFilters = (filters: IMarketFilters) => {
    router.replace({ query: parseQueryParams({ ...filters }) }, undefined, {
      shallow: true,
    });
  };

  const onFiltersUpdate = (newFilters: IMarketFilters) => {
    setFilters({ ...filterValues, ...newFilters });
  };

  const onResetFilters = () => {
    setFilters({
      category: filterValues.category,
      sortBy: filterValues.sortBy,
    });
  };

  return {
    items: getPagesItems(data?.pages),
    hasNextPage,
    ...filterValues,
    error,
    isLoading,
    onFiltersUpdate,
    onResetFilters,
    onFetchNextPageMarket: fetchNextPage,
  };
}

export default useMarket;
